var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftBgTrustDonors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 133,
    viewBox: "0 0 295 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295 36.75H94.7602C84.8191 36.75 76.7602 28.6911 76.7602 18.75C76.7602 8.80887 68.7013 0.75 58.7602 0.75L4.76837e-07 0.75",
    stroke: "#D9D9D9",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295 36.75H94.7602C84.8191 36.75 76.7602 28.6911 76.7602 18.75C76.7602 8.80887 68.7013 0.75 58.7602 0.75L4.76837e-07 0.75",
    stroke: "url(#paint0_linear_171730_2749)",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M295 95.75H94.7602C84.8191 95.75 76.7602 103.809 76.7602 113.75C76.7602 123.691 68.7013 131.75 58.7602 131.75L4.76837e-07 131.75",
    stroke: "#D9D9D9",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295 95.75H94.7602C84.8191 95.75 76.7602 103.809 76.7602 113.75C76.7602 123.691 68.7013 131.75 58.7602 131.75L4.76837e-07 131.75",
    stroke: "url(#paint1_linear_171730_2749)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_171730_2749",
    x1: 203.189,
    y1: 49.5,
    x2: 147.589,
    y2: 18.5899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231949,
    stopColor: "#3292FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569175,
    stopColor: "#3292FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3292FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_171730_2749",
    x1: 203.189,
    y1: 83,
    x2: 147.589,
    y2: 113.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231949,
    stopColor: "#3292FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569175,
    stopColor: "#3292FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3292FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBgTrustDonors);
export default __webpack_public_path__ + "static/media/left_bg_trust_donors.3efbb7c91a5415b5ec0f5f71000c1566.svg";
export { ForwardRef as ReactComponent };